import {EyeOutlined, FileTextOutlined} from '@ant-design/icons';
import {Button, Modal} from 'antd';
import {ColumnProps} from 'antd/lib/table';
import {Storage} from 'aws-amplify';
import {AnchorLink, SimpleTable} from 'components';
import {useUserContext} from 'hooks/useUserContext';
import moment from 'moment-timezone';
import React, {useState} from 'react';
import {config} from 'stage.config';
import styled from 'styled-components';

type Props = {};

const IFrame = styled.iframe`
  width: 100%;
  height: 80vh;
  max-height: 1280px;
  border: 0;
  display: block;
`;

type LegalDoc = {
  title: string;
  url: string;
  date?: string;
};

export const LegalDocs: React.FC<Props> = () => {
  const currentUser = useUserContext();
  const [selectedDoc, setSelectedDoc] = useState<LegalDoc | null>(null);

  const handleSelectDoc = async (doc: LegalDoc) => {
    const regex = /https?:\/\/[^\/]+\/([^?#]+)/;
    const match = doc.url.match(regex);
    if (!match || !match[1]) {
      return;
    }
    const [level, identityId, key] = match[1].split('/');
    const signedUrl = await Storage.get(key, {
      level: level as any,
      identityId,
      bucket: config.adminBucket
    });
    setSelectedDoc({...doc, url: signedUrl});
  };

  const data: any = [
    {
      title: 'Legal Notice',
      url: currentUser.termsOfServiceUrl,
      date: currentUser.termsOfServiceAcceptedAt
    }
  ];

  const columns: Array<ColumnProps<LegalDoc>> = [
    {
      title: 'Document',
      dataIndex: 'title',
      render: (title) => (
        <>
          <FileTextOutlined /> {title}
        </>
      )
    },
    {
      title: 'Date',
      dataIndex: 'date',
      className: 'minimized-cell',
      render: (date: string) => (date ? moment(date).format('ll') : undefined)
    },
    {
      title: 'Actions',
      key: 'actions',
      className: 'minimized-cell',
      align: 'right',
      render: (_, doc) => {
        return (
          <AnchorLink onClick={() => handleSelectDoc(doc)}>
            <EyeOutlined /> Review
          </AnchorLink>
        );
      }
    }
  ];

  return (
    <>
      <h2>Legal documents</h2>
      <SimpleTable rowKey="title" dataSource={data} columns={columns as any} pagination={false} />
      <Modal
        width={800}
        open={!!selectedDoc}
        destroyOnClose
        closable={false}
        title={false}
        onCancel={() => setSelectedDoc(null)}
        centered
        bodyStyle={{padding: 0}}
        footer={[
          <Button key="close" onClick={() => setSelectedDoc(null)}>
            Close
          </Button>
        ]}>
        <IFrame title={selectedDoc?.title} src={`${selectedDoc?.url}#view=fitH`} />
      </Modal>
    </>
  );
};
